var map = {
	"./battery": [
		3404,
		404
	],
	"./battery.tsx": [
		3404,
		404
	],
	"./default": [
		6842,
		842
	],
	"./default.tsx": [
		6842,
		842
	],
	"./demo-adc": [
		8296,
		296
	],
	"./demo-adc.tsx": [
		8296,
		296
	],
	"./sht30": [
		7856,
		856
	],
	"./sht30.tsx": [
		7856,
		856
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 7576;
module.exports = webpackAsyncContext;